import {Box, Paper} from '@mui/material';
import React, {useRef} from 'react';
import Controls from '../../components/Slider/Controls';
import Header from '../../components/Slider/Header';
import LocationForm from '../../forms/LocationForm';
import EndUserLocations from './EndUserLocations';

const NewEndUserLocation = ({onBack, onNext, session}) => {
  /** @type {({current: LocationForm})} */
  const formRef = useRef();
  return (
    <>
      <Header>Create a New Location</Header>
      <Paper component={Box} padding={2}>
        <LocationForm ref={formRef} type="contact" location={{}} parent={session.selectedEndUser} onSaved={() => onNext(
          {type: EndUserLocations.type, id: EndUserLocations.type}
        )}/>
      </Paper>
      <Controls
        onBack={() => onBack({type: EndUserLocations.type, id: EndUserLocations.type})}
        onNext={() => formRef.current.save()}
        nextLabel="Save New Location"
      />
    </>
  );
};

NewEndUserLocation.type = 'NEW_END_USER_LOCATION';

export default NewEndUserLocation;
